/** @format */
import { Aside } from '@mpb-com/feather/components/atoms/aside';
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import ChevronDown from '@toucan/client/global/icons/chevron-down.svg';

import { AsideMenuStyleProps, styles } from './aside-menu.styles';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type AsideMenuProps = {
    children: ReactNode;
    'data-testid'?: string;
    className?: string;
    title: ReactNode;
    titleExtraContent?: ReactNode;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

const StyledAsideMenu = styled('div')<AsideMenuStyleProps>`
    ${styles}
`;

export const AsideMenu: FunctionComponent<AsideMenuProps> = ({
    title,
    titleExtraContent,
    children,
    isOpen,
    setIsOpen,
    ...otherProps
}: AsideMenuProps) => {
    const { t } = useTranslation();

    function toggleOpen() {
        setIsOpen(!isOpen);
    }

    return (
        <StyledAsideMenu
            $isOpen={isOpen}
            // eslint-disable-next-line @mpb-com/mpb/transient-props-last -- Legacy code: do not use as an example.
            data-testid="aside-menu"
            {...otherProps}
        >
            <Aside border>
                <div className="aside-menu__title-container">
                    <div
                        className="aside-menu__title"
                        data-testid="aside-menu__title"
                        onClick={toggleOpen}
                    >
                        {title}
                        <span role="img" aria-label={t('Expand')}>
                            <Icon
                                variant={IconVariant.ACTIONABLE}
                                className="toggle-button"
                                size={IconSize.S}
                                data-testid="aside-menu__toggle-button"
                            >
                                <ChevronDown />
                            </Icon>
                        </span>

                        <div
                            className="aside-menu__title-extra-content"
                            data-testid="aside-menu__title__extra-content"
                        >
                            {titleExtraContent}
                        </div>
                    </div>
                </div>

                <div
                    className="aside-menu__content-container"
                    data-testid="aside-menu__content"
                    aria-hidden={!isOpen}
                >
                    <div className="aside-menu__content">{children}</div>
                </div>
            </Aside>
        </StyledAsideMenu>
    );
};
